<div class="dialog-body" *ngIf="!customContent(); else customBodyContent" [innerHTML]="body"></div>

<ng-template #customBodyContent>
  <ng-content select="[napaCustomDialogContent]"></ng-content>
</ng-template>